import axios from "axios";
import { _post, API_URL } from "../../constants/config";

export const getCatgories = async (accessToken) => {
  let url = `${API_URL}ops/api/categories`;

  try {
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization" : `Bearer ${accessToken}`
        // "Access-Token" : `${accessToken}`
      }
    });
    return response.data;
  } catch(err) {
    console.log(err);
  }

}